module.exports = __webpack_public_path__ + "static/media/House_Beer_Product_Launch.c911c1aa.png";